<template>
  <div class="hero-section" v-parallax-zone>
    <div>
      <div class="background-elements"><div id="deep-blue"></div></div>
      <div class="content">
        <div id="sunrise"></div>
        <!-- Main centeral content -->
        <div class="main-content">
          <div class="middle">
            <!-- Clouds -->
            <div class="clouds">
              <div id="cloud-1" parallax-child="6">
                <img src="@/assets/images/cloud-1.png" width="250" />
              </div>
              <div id="cloud-2" parallax-child="4">
                <img src="@/assets/images/cloud-2.png" width="200" />
              </div>
              <div id="cloud-3" parallax-child="2">
                <img src="@/assets/images/cloud-3.png" width="100" />
              </div>
            </div>
            <!-- KwD Logo -->
            <GraphicCompLogo />
            <!-- KwD Logo (Mobile) -->
            <div class="hero-button" parallax-child="10">
              <AppButton @click="$root.openShop">Available Now!</AppButton>
            </div>
          </div>
          <div class="bottom"></div>
        </div>
        <div id="foreground" class="img-wrapper" parallax-child="10">
          <img id="hill" src="@/assets/images/foreground.png" />
          <div class="kids">
            <img id="kid-1" src="@/assets/images/kid-1.png" />
            <img id="kid-2" src="@/assets/images/kid-2.png" />
            <img id="kid-3" src="@/assets/images/kid-3.png" />
            <img id="kid-4" src="@/assets/images/kid-4.png" />
          </div>
        </div>
        <div id="ground" class="img-wrapper" parallax-child="3">
          <div></div>
        </div>
        <div id="mountains" class="img-wrapper" parallax-child="2">
          <div></div>
        </div>
      </div>
      <div class="scroll-indctr">
        <div>
          <span><FA icon="chevron-down"/></span>
          <p>Scroll to learn!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfoBanner from '@/components/InfoBanner';
import GraphicCompLogo from '@/components/GraphicCompLogo';

@Component({
  components: {
    InfoBanner,
    GraphicCompLogo
  }
})
class SectionHero extends Vue {}

export default SectionHero;
</script>

<style lang="scss" scoped>
@import 'vars';

@mixin graphic-anim-pos($x: 0, $y: 0) {
  $name: unique-id();

  @keyframes #{$name} {
    0% {
      transform: translate($x, $y);
    }

    100% {
      transform: translate(0, 0);
    }
  }

  animation-name: $name;
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.hero-section {
  background: white;
  position: relative;
  z-index: 10;

  .img-wrapper {
    position: relative;
  }

  .background-elements {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    background: linear-gradient(#0e89ff, #00ccff);
    z-index: 1;
  }

  .content {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 2;

    .main-content {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      z-index: 200;
      max-width: 600px;
      margin: 0 auto;

      > .top {
        margin-top: 100px;
        min-height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;

        .partners {
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99;
          animation: fadeIn 1s both;
          animation-delay: 1.5s;

          > a {
            transition: 0.25s;

            > img {
              margin: 20px 40px;
              height: 60px;
            }

            &:hover {
              transform: scale(1.1);
            }
          }
        }

        @media only screen and (max-width: 600px) {
          .partners > a > img {
            margin: 10px 20px;
            height: 30px;
          }
        }
      }

      > .middle {
        flex-grow: 1;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 150px;

        > .hero-button {
          // margin: 20px 0;
          margin-bottom: -30px;
          margin-top: 30px;
          flex-shrink: 0;
          z-index: 2;
        }
      }

      > .bottom {
        height: 400px;
        flex-shrink: 0;
        /* background: green; */
      }
    }
  }

  @media only screen and (max-width: 600px) {
    .content {
      min-height: 850px;
    }
  }

  .scroll-indctr {
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 10;

    > div {
      display: inline-block;
      padding: 10px 20px;
      background: #0e89ff;
      border-radius: 18px;
      color: white;
      box-shadow: 0 10px 60px #00000063;

      > span {
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        top: -70px;
        // background: white;
        background: #0e89ff;
        width: 45px;
        height: 45px;
        font-size: 25px;
        border-radius: 100%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 10px 60px #00000063;

        animation-name: floating;
        animation-duration: 1s;
        animation-iteration-count: infinite;

        @keyframes floating {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(20px) scaleY(0.8);
          }
          100% {
            transform: translateY(0);
          }
        }
      }

      > p {
        font-size: 20px;
        line-height: 1em;
        margin: 0;
      }
    }
  }

  > div {
    height: 85vh;
    min-height: 950px;
    position: relative;
    animation: fadeIn 1s both;
    animation-delay: 0.05s;

    @include mobile-mode {
      height: 75vh;
    }
  }
}

#coming-soon {
  text-align: center;
}

#logo-mobile {
  max-width: 300px;
  width: calc(100% - 40px);
  z-index: 99;
  display: none;
}

@media only screen and (max-width: 600px) {
  #logo-mobile {
    display: inline-block;
  }
}

#deep-blue {
  position: absolute;
  top: -250px;
  width: 1000px;
  height: 600px;
  background: radial-gradient(
    ellipse at center,
    #014cd9 0%,
    rgba(125, 185, 232, 0) 50%
  );
  z-index: 1;
}

#sunrise {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 1000px;
  // background: linear-gradient(rgba(250, 255, 145, 0), #f9ff91);
  background: linear-gradient(rgba(250, 255, 145, 0), #fffdbd);
  z-index: 0;
  animation: fadeIn 1s;
}

.clouds {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}

#cloud-1 {
  position: absolute;
  top: 15%;
  z-index: 2;
  left: -80px;

  img {
    width: 250px;
    @include graphic-anim-pos(0, 80px);
  }
}

#cloud-2 {
  position: absolute;
  top: 60%;
  z-index: 2;
  right: -80px;

  img {
    width: 200px;
    @include graphic-anim-pos(0, 70px);
  }
}

#cloud-3 {
  position: absolute;
  top: 80%;
  z-index: 2;
  left: -30px;

  img {
    width: 100px;
    @include graphic-anim-pos(0, 60px);
  }
}

#foreground {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  z-index: 3;
  display: flex;
  justify-content: center;
}

#hill {
  animation: foreground 1s both;
  animation-delay: 0.1s;
  position: absolute;
  /* bottom: 0; */
  bottom: -30px;
  width: 1400px;

  @include graphic-anim-pos(0, 200px);
}

.kids {
  position: absolute;
  bottom: 70px;
  z-index: 4;

  > img {
    width: 100px;
    position: absolute;
    bottom: 0;
    z-index: 4;
  }
}

#kid-1 {
  right: 140px;
  animation: kids 0.5s both cubic-bezier(0.26, 2.1, 0.58, 0.99);
  animation-delay: 1.25s;
}

@media only screen and (max-width: 600px) {
  #kid-1 {
    right: 20px;
  }
}

#kid-2 {
  left: 140px;
  animation: kids 0.5s both cubic-bezier(0.26, 2.1, 0.58, 0.99);
  animation-delay: 1.3s;
}

@media only screen and (max-width: 600px) {
  #kid-2 {
    left: 20px;
  }
}

#kid-3 {
  // width: 110px;
  width: 90px;
  right: 20px;
  bottom: 30px;
  animation: kids 0.5s both cubic-bezier(0.26, 2.1, 0.58, 0.99);
  animation-delay: 1.35s;
}

@media only screen and (max-width: 600px) {
  #kid-3 {
    display: none;
  }
}

#kid-4 {
  // width: 110px;
  width: 90px;
  left: 20px;
  bottom: 30px;
  animation: kids 0.5s both cubic-bezier(0.26, 2.1, 0.58, 0.99);
  animation-delay: 1.4s;
}

@media only screen and (max-width: 600px) {
  #kid-4 {
    display: none;
  }
}

@keyframes kids {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

#ground {
  position: absolute;
  width: 100vw;
  bottom: -40px;
  z-index: 1;
  display: flex;
  justify-content: center;

  > div {
    height: 200px;
    width: calc(100% + 40px);
    background: linear-gradient(#67cea0, #72df4a);
    animation-delay: 0.1s;
    flex-shrink: 0;

    @include graphic-anim-pos(0, 100px);
  }
}

#mountains {
  position: absolute;
  width: 100vw;
  bottom: 100px;
  display: flex;
  justify-content: center;

  > div {
    height: 204px;
    width: calc(100% + 40px);
    background: url(~@/assets/images/mountains.png);
    background-size: 640px;
    background-position: bottom;
    background-repeat: repeat-x;
    flex-shrink: 0;

    @include graphic-anim-pos(0, 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionHero.vue